/**
 * Policy Dialog Mode
 *
 * Defines the operational mode for policy creation and editing dialogs.
 * Used by CreatePolicyDialog to determine dialog behavior, form initialization,
 * and which mutation (create/update) to execute.
 *
 * @public
 */
export enum PolicyDialogMode {
  /**
   * Create mode - Empty form for creating a new policy
   * - Dialog title: "Create Policy"
   * - Form: Empty fields
   * - Submit: Creates new policy via createPolicy mutation
   */
  Create = 'create',

  /**
   * Edit mode - Pre-filled form for updating an existing policy
   * - Dialog title: "Edit Policy"
   * - Form: Pre-filled with existing policy data
   * - Submit: Updates existing policy via updatePolicy mutation
   */
  Edit = 'edit',

  /**
   * Duplicate mode - Pre-filled form for copying an existing policy
   * - Dialog title: "Duplicate Policy"
   * - Form: Pre-filled with existing policy data, name prefixed with "Copy of..."
   * - Submit: Creates new policy via createPolicy mutation
   */
  Duplicate = 'duplicate',
}
